import { twMerge } from "@/lib/twMerge";

/** A ring spinner in the current text color. Decorative — pair it with visible text
 * (or put it inside an element with role="status") so screen readers get the state.
 * Holds still for users who've asked for reduced motion. */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={twMerge(
        "inline-block h-4 w-4 shrink-0 rounded-full border-2 border-current border-r-transparent",
        "motion-safe:animate-spin motion-reduce:opacity-60",
        className,
      )}
    />
  );
}
